// Packages
import { Component } from "react";
import { Link } from "react-router-dom";

// Styles
import "./schoolAdmin.css";

// Material Ui
import MaterialTable from "material-table";

// All Urls

// Services
import userService from "../../services/user.service";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";

// Assets
import menuthree from "../../assets/images/menuthree.png";
import backArrow from "../../assets/images/backArrow.png";

// const data = [
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Head Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Head Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
// ];

const columns = [
  { title: "id", field: "id", hidden: true },
  { title: "COACH NAME", field: "firstName" },

  // {title:'', field:'firstName'},
  // {title:'NAME', field:'firstName'},
  {
    title: "SIGN-UP DATE",
    field: "lastName",
    type: "date",
    dateSetting: { locale: "en-US" },
  },
  { title: "ATHLETES", field: "email" },
  { title: "SPECIALITY", field: "createdAt" },
  { title: "PHONE NO", field: "specialty" },
  { title: "STATUS", field: "remaining" },
  {
    render: (rowData) => (
      <div class="dropdown">
        <span className="cp">
          <img className="cp" src={menuthree} alt="menu"></img>{" "}
        </span>
        <div class="dropdown-content">
          {/* { allSchoolList && allSchoolList.map((item, index) => (   */}
          <Link className="p-0" to={`/editteams/${rowData.id}`}>
            {/* <label className="cp">Edit Team Details</label> */}
          </Link>
          {/* ))} */}
          {/* <label className="cp">Reset Password</label> */}
          {/* <label className="cp red" onClick={this.openDialog.bind(this)}>Delete</label> */}
          {/* onClick={this.openDialog.bind(this)} */}
        </div>
      </div>
    ),
  },
];

class Storage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
    };
  }
  componentDidMount() {
    const team = document.getElementById("Team");
    if (team) {
      team.classList.add("btnActive");
    }
    this.getSchoolData();
  }

  getSchoolData() {
    userService
      .getAllCoaches()
      .then((response) => {
        console.log(response);
        var allSchoolList = response.data.data.coaches;
        console.log(allSchoolList);
        this.setState({ allSchoolList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  render() {
    return (
      <div className="content">
        <div className="content-layout p-0">
          <SchoolAdminDashboard />
          {/* <div className="clear10"></div> */}
          <div className="container">
            <div className="row">
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                {/* <h4 className="fs-24 black bold ml-14">TEAMS</h4> */}
                <p>
                  <Link to="/schoolteams">
                    <span className="fs-22 black semi-bold">TEAMS</span>
                  </Link>{" "}
                  <img src={backArrow} alt="" />{" "}
                  <span>TEAM NAME HERE:Athletes</span>
                </p>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="clear20"></div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <MaterialTable
              title=""
              data={this.state.allSchoolList}
              columns={columns}
              options={{
                selection: true,
                headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                pageSize: 10,
              }}
            ></MaterialTable>
          </div>
        </div>
      </div>
    );
  }
}
export default Storage;
